// Dora-source summary for the result line. Shows EVERY non-zero dora source broken out — ドラ/赤/裏 AND
// 北(kita)/花(flower)/隣(dora-neighbor). The earlier result display summed only dora+aka+ura, so 花牌
// (flower dora) and 北抜き(kita) were already in the POINTS but never shown — reading as "花牌がドラに
// ならない". Pure + no React/?url imports so it is unit-testable in plain Node/vitest.
import type { ScoreResult } from '@mj/protocol';

export function doraSummary(db: ScoreResult['doraBreakdown']): string {
  const parts = ([['ドラ', db.dora], ['赤', db.aka], ['裏', db.ura], ['北', db.kita], ['花', db.flower], ['隣', db.neighbor]] as [string, number][])
    .filter(([, v]) => v > 0)
    .map(([k, v]) => `${k}${v}`);
  return parts.length ? ` ・ ${parts.join(' ')}` : '';
}
